<template>
  <v-content>
    <v-container fluid>
      <v-row no-gutters>
          <v-col cols="12">
              <v-card class="pa-2" raised outlined tile>
                <v-card-title>
                    {{ pagetitle }}
                </v-card-title>
                <v-card-text v-html='pagedata'></v-card-text>
              </v-card>
          </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import {
  FETCH_INDIVIDUAL_PAGE,
  PAGES_RESET_STATE
} from "@/store/actions.type"
import { mapGetters } from "vuex"
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store"

export default {
    name:'Pages',
    async beforeRouteUpdate(to, from, next) {
        let language    =   store.state.translations.curLanguage
        await store.dispatch(FETCH_INDIVIDUAL_PAGE, '?page_slug='+to.params.slug+'&lang_ids='+language.lang_id).then(resp => {
        if (resp.success) {
            store.commit(SET_LOADING, false)
        }
        })             
        
        return next();
    },
    async beforeRouteEnter(to, from, next) {  
        let language    =   store.state.translations.curLanguage
        await store.dispatch(FETCH_INDIVIDUAL_PAGE, '?page_slug='+to.params.slug+'&lang_ids='+language.lang_id).then(resp => {
        if (resp.success) {
            store.commit(SET_LOADING, false)
            store.commit(SET_ROUTER_ENTER, false)

        }
        })         
        return next();
    },
    async beforeRouteLeave(to, from, next) {
        await store.dispatch(PAGES_RESET_STATE)
        next();
    },  
    computed: {
        ...mapGetters(["individualpage"]),
        language(){
            return this.$store.state.translations.curLanguage
        },

    }, 
    data: function() {
        return {
            pagetitle: null,
            pagedata: null,   
        }
    },
  watch: {
    language (newLanguage) {
        this.getPageData(newLanguage)
    }
  }, 
  created() {
      this.pagetitle= this.individualpage[0].page_title
      this.pagedata=    this.individualpage[0].page_content
  },
    methods: {
        async getPageData(newLanguage){
            await store.dispatch(FETCH_INDIVIDUAL_PAGE, '?page_slug='+this.$route.params.slug+'&lang_ids='+newLanguage.lang_id).then(resp => {
            if (resp.success) {
                store.commit(SET_LOADING, false)
            }
            })   
        }
    }           
}
</script>